export const formatDocumentTitle = (
  whiteLabel: string,
  pageTitle?: string,
): string => (pageTitle ? `${whiteLabel} - ${pageTitle}` : whiteLabel);
